"use client";

import type {ComponentProps} from "react";
import {SiteClientProviders} from "./SiteClientProviders";
import {ClientMeetingProvider} from "./client/MeetingProvider";

export function ClientProviders({children, ...props}: ComponentProps<typeof SiteClientProviders>) {
    return <SiteClientProviders {...props}>
        <ClientMeetingProvider>{children}</ClientMeetingProvider>
    </SiteClientProviders>;
}
